import { render, staticRenderFns } from "./template5.vue?vue&type=template&id=569ef4c9&"
import script from "./template5.vue?vue&type=script&lang=ts&"
export * from "./template5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports